import { render, staticRenderFns } from "./NewTptPatient.vue?vue&type=template&id=ba97639c&scoped=true"
import script from "./NewTptPatient.vue?vue&type=script&lang=js"
export * from "./NewTptPatient.vue?vue&type=script&lang=js"
import style0 from "./NewTptPatient.vue?vue&type=style&index=0&id=ba97639c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba97639c",
  null
  
)

export default component.exports